// extracted by mini-css-extract-plugin
export default {"b_r_adiv":"Btnredo_b_r_adiv__BiHFD","pressed":"Btnredo_pressed__KSgbO","b_r_img":"Btnredo_b_r_img__S5OnI"};